export enum PROVIDERS {
  metamask = 'metamask',
  okx = 'okx',
  trust = 'trust',
  coinbase = 'coinbase'
}
